import * as InlineAdditionalFiltersLabel from './InlineAdditionalFiltersLabel';
import * as InlineComparisonLabelV2 from './InlineComparisonLabelV2';
import * as InlineDateRangeAndFrequencyLabel from './inlineDateRangeAndFrequency/InlineDateRangeAndFrequencyLabel';
import * as InlineLimitedDataWarningLabel from './InlineLimitedDataWarningLabel';
import * as InlineMigrationLabel from './InlineMigrationLabel';
import * as InlineMultiAccountLabel from './InlineMultiAccountLabel';
export const INLINE_LABEL_TYPES = {
  DATE: 'DATE',
  COMPARE: 'COMPARE',
  FILTERS: 'FILTERS',
  LIMITED_DATA: 'LIMITED_DATA',
  MIGRATION: 'MIGRATION',
  MULTI_ACCOUNT: 'MULTI_ACCOUNT'
};
const INLINE_LABELS = {
  [INLINE_LABEL_TYPES.DATE]: InlineDateRangeAndFrequencyLabel,
  [INLINE_LABEL_TYPES.COMPARE]: InlineComparisonLabelV2,
  [INLINE_LABEL_TYPES.FILTERS]: InlineAdditionalFiltersLabel,
  [INLINE_LABEL_TYPES.MIGRATION]: InlineMigrationLabel
};
const WARNING_LABELS = [InlineLimitedDataWarningLabel, InlineMultiAccountLabel];
const INLINE_LABELS_IN_ORDER = Object.keys(INLINE_LABELS);
export const getInlineLabelComponents = (inlineLabelTypes = INLINE_LABELS_IN_ORDER, useInlineLabels = true) => [...(useInlineLabels ? INLINE_LABELS_IN_ORDER.filter(type => inlineLabelTypes.includes(type)).map(type => INLINE_LABELS[type]) : []), ...WARNING_LABELS];